const imageWidths = [
  100, 116, 134, 156, 182, 210, 244, 282, 328, 380, 442, 512, 594, 688, 798, 926, 1074, 1246, 1446, 1678, 1946, 2258,
  2618, 3038, 3524, 4088, 4742, 5500,
];

// NOTE: if in a for loop, use 'x-bind:key' so that the image is updated
export default ({ imageUrl }) => ({
  get srcset() {
    if (!imageUrl) return false;

    const url = new URL(imageUrl.startsWith('//') ? `https:${imageUrl}` : imageUrl);

    return imageWidths
      .map((width) => {
        url.searchParams.set('width', width);

        return `${url.toString()} ${width}w`;
      })
      .join(', ');
  },

  imgAttributes(config) {
    return {
      class: config.cover ? 'h-full object-cover' : 'h-full object-contain',
      loading: config.isLazy ? 'lazy' : 'eager',
      ['x-bind:srcset']() {
        return this.srcset;
      },
      ['x-bind:src']() {
        return imageUrl;
      },
      alt: config.alt || '',
    };
  },
});
